// extracted by mini-css-extract-plugin
module.exports = {"brandLogo":"RotatingBrandLogo_brandLogo__EAjlt"};